export default {
  feedDesignatorList: [],
  uniqueDesignators: [],
  feedDesignator: []
}
